import React from 'react';

export const QuestionSquare: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M6.45647 6.45642C6.61448 5.77538 7.23477 5.30318 7.9333 5.33217C8.71508 5.28887 9.38527 5.8846 9.43393 6.66606C9.43393 7.66909 8 7.99995 8 8.6669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="1.9975"
      y="1.99744"
      width="12.005"
      height="12.005"
      rx="3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.08336 10.5011C8.08336 10.5471 8.04603 10.5844 7.99999 10.5844C7.95395 10.5844 7.91662 10.5471 7.91662 10.5011C7.91662 10.455 7.95395 10.4177 7.99999 10.4177"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99999 10.4176C8.04604 10.4176 8.08336 10.455 8.08336 10.501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
